import { useSelector } from 'react-redux';
import Hightlighter from 'react-highlight-words';
import * as S from './ChooseApplications.styled';
import { ImageWithFallback } from 'components';
import EmptyIcon from 'assets/images/EmptyIcon.svg';

export const Content = ({ foundedApps, search, isActive, toggle, isGlobal }) => {
  const showAppName = useSelector((state) => state.auth.show_app_name);

  return (
    <S.ItemsGroup>
      {foundedApps?.map(({ pba_name, pba_number, image_url, package: packageName }) => (
        <S.Item
          key={pba_number}
          isActive={isActive(pba_number)}
          onClick={() => !isGlobal(pba_number) && toggle(true, pba_number)}
          isDisabled={isGlobal(pba_number)}
        >
          {showAppName && (
            <S.Icon>
              <ImageWithFallback
                src={`https://cdn.appnext.com/apps/${image_url}`}
                fallbackSrc={EmptyIcon}
              />
            </S.Icon>
          )}
          <S.ItemContent>
            <S.NameRow>
              <Hightlighter
                textToHighlight={showAppName ? pba_name ?? '' : `App ID: ${pba_number ?? ''}`}
                searchWords={[search]}
                highlightTag='strong'
              />
            </S.NameRow>
            {showAppName && (
              <S.Data>
                {showAppName && <S.Package>{packageName}</S.Package>}
                <S.Id>{pba_number}</S.Id>
              </S.Data>
            )}
          </S.ItemContent>
        </S.Item>
      ))}
    </S.ItemsGroup>
  );
};
